/**
 * Mock Twilio implementation for testing
 */

export interface MockCallResult {
  success: boolean;
  callSid: string;
  status: string;
  startTime: string;
  error?: string;
  code?: string;
}

// Mock implementation for Twilio calling when credentials are not available
export const MOCK_MODE = !import.meta.env.VITE_TWILIO_SID || !import.meta.env.VITE_TWILIO_AUTH;

export const mockMakeCall = async (to: string) => {
  console.log('🎭 Mock: Making call to', to);
  
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Different responses based on phone number for testing
  if (to.includes('1234')) {
    return {
      success: false,
      error: 'The number you have dialed is not in service',
      code: 'INVALID_NUMBER'
    };
  }
  
  if (to.includes('5555')) {
    return {
      success: false,
      error: 'Line busy',
      code: 'BUSY'
    };
  }
  
  // Default success case - simulates successful two-way call
  return {
    success: true,
    callSid: `CA${Math.random().toString(36).substr(2, 32)}`,
    status: 'initiated',
    startTime: new Date().toISOString(),
  };
};

export const mockEndCall = async (callSid: string) => {
  console.log('🎭 Mock Call ended:', callSid);
  await new Promise(resolve => setTimeout(resolve, 500));
  return { success: true };
};

export const mockGetCallStatus = async (callSid: string) => {
  console.log('🎭 Mock Call status check:', callSid);
  
  // Simulate call progression
  const elapsed = Date.now() % 30000; // 30 second cycle
  
  if (elapsed < 3000) return { success: true, status: 'queued' };
  if (elapsed < 6000) return { success: true, status: 'ringing' };
  if (elapsed < 25000) return { success: true, status: 'in-progress' };
  return { success: true, status: 'completed' };
};

export const mockMuteCall = async (callSid: string, mute: boolean) => {
  console.log(`🎭 Mock Call ${mute ? 'muted' : 'unmuted'}:`, callSid);
  return { success: true, muted: mute };
};
